import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import {type ReactNode} from "react";

import {addStyle, View} from "@khanacademy/wonder-blocks-core";
import {
    border,
    font,
    semanticColor,
    sizing,
} from "@khanacademy/wonder-blocks-tokens";
import {LabelSmall} from "@khanacademy/wonder-blocks-typography";

interface Props {
    id: string;
    label: string;
    description?: string;
    required?: boolean;
    error?: string | null;
    children: ReactNode;
}

const StyledSpan = addStyle("span");

export const RequestedInputLabel = ({
    id,
    label,
    required,
    description,
    error,
    children,
}: Props) => {
    return (
        <View style={styles.row}>
            <LabelSmall tag="label" htmlFor={id} style={styles.label}>
                {label}
                {required && (
                    <StyledSpan
                        style={styles.requiredMarker}
                        aria-label={t`Required`}
                    >
                        *
                    </StyledSpan>
                )}
            </LabelSmall>
            {description && (
                <LabelSmall style={styles.description}>
                    {description}
                </LabelSmall>
            )}
            {children}
            {error && (
                <LabelSmall
                    style={styles.error}
                    role="alert"
                    aria-live="assertive"
                >
                    {error}
                </LabelSmall>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    row: {
        width: "100%",
        gap: sizing.size_060,
    },
    label: {
        fontWeight: "bold",
        fontSize: font.size.medium,
    },
    description: {
        color: semanticColor.core.foreground.neutral.default,
    },
    requiredMarker: {
        color: semanticColor.status.critical.foreground,
    },
    error: {
        borderRadius: border.radius.radius_040,
        alignItems: "center",
        justifyContent: "center",
        padding: sizing.size_120,
        background: semanticColor.status.critical.background,
        border: `1px solid ${semanticColor.status.critical.foreground}`,
    },
});
